export default "__VITE_ASSET__DPPhgzKr__"